export default function collinaInit({
  location,
  umidToken,
  collinaCdnServer,
  collinaJsServer,
}) {
  if (!window.UA_Opt) {
    const UA_Opt = {};
    window.UA_Opt = UA_Opt;
    UA_Opt.SendMethod = 9;
    UA_Opt.ExTarget = ['password'];
    UA_Opt.FormId = 'login_submit_form';
    UA_Opt.LogVal = 'uaInputVar';
    window[UA_Opt.LogVal] = '';
    UA_Opt.Token = new Date().getTime() + ':' + Math.random();
    UA_Opt.MaxMCLog = 50;
    UA_Opt.MaxKSLog = 50;
    UA_Opt.MaxMPLog = 50;
    UA_Opt.MaxTCLog = 50;
    UA_Opt.MaxFocusLog = 50;
    UA_Opt.Flag = 1670350;
  }

  function getUA() {
    const tmp_ua = window[window.UA_Opt.LogVal];
    window.UA_Opt.Token = new Date().getTime() + ':' + Math.random();
    window.UA_Opt.reload();
    return tmp_ua;
  }
  window.getUA = getUA;

  const m = document.getElementsByTagName('script')[0];
  const uaStartTime = new Date().getTime();
  function _uaJSComplete(flag) {
    if (typeof window.acjs == 'undefined') {
      const _script = document.createElement('script');
      _script.src = `${collinaJsServer}/js/uab.js`;
      m.parentNode.insertBefore(_script, m);
    }
    if (!window.dmtrack) {
      return;
    }
    if (flag === 'error') {
      window.dmtrack.dotstat(13669);
    } else if (flag === 'load') {
      const loadTime = new Date().getTime() - uaStartTime;
      window.dmtrack.dotstat(13670, 'ext=loadTime=' + loadTime);
    }
  }
  window._uaJSComplete = _uaJSComplete;

  const s = document.createElement('script');
  s.async = 1;
  s.src = `${collinaCdnServer}/js/uab.js`;
  s.onerror = function() {
    _uaJSComplete('error');
  };
  s.onload = function() {
    _uaJSComplete('load');
  };
  m.parentNode.insertBefore(s, m);

  const $umfp = document.createElement('div');
  $umfp.setAttribute('id', '_umfp');
  $umfp.setAttribute(
    'style',
    'display:inline;width:1px;height:1px;overflow:hidden',
  );
  document.body.appendChild($umfp);

  function loadPointMan() {
    window._pointman_q = window._pointman_q || [];
    window._pointman_q.push([
      'um',
      function(umx) {
        const container = document.getElementById('_umfp');
        umx.init({
          timeout: 3000,
          serviceLocation: location === 'us' || location === 'sg' ? 'us' : 'cn',
          appName: 'aisn-detail',
          token: umidToken || '',
          containers: { flash: container, dcp: container },
        });
      },
    ]);

    const s = document.createElement('script');
    const m = document.getElementsByTagName('script')[0];
    s.async = 1;
    s.crossOrigin = 'anonymous';
    s.src =
      'https://assets.alicdn.com/g/sd/pointman/js/pt2.js?_=' +
      Math.floor(new Date().getTime() / 36e5);
    m.parentNode.insertBefore(s, m);
  }

  if (document.readyState !== 'loading' || !document.addEventListener) {
    loadPointMan();
  } else {
    document.addEventListener('DOMContentLoaded', loadPointMan);
  }
}
